import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/[variants]/goods-detail/[shop_sku]/page.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/components/GlobalDialog/Loading/LoadingFallback.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/components/RouteMessagesProvider.tsx");
